import fetcher from 'helpers/fetcher';

export default {
	fetch (params) {
		return fetcher.get('open/country', {}, { params });
	},
};
